import React from 'react';
import { ServiceContext } from './ServiceContext';
import { ChartOfAccountsService } from '../services/ChartOfAccountsService';
import { FiscalSponsorService } from '../services/FiscalSponsorService';
import { Form990Service } from '../services/Form990Service';

interface ServiceProviderProps {
  children: React.ReactNode;
}

export const ServiceProvider: React.FC<ServiceProviderProps> = ({ children }) => {
  const services = {
    chartOfAccountsService: new ChartOfAccountsService(),
    fiscalSponsorService: new FiscalSponsorService(),
    form990Service: new Form990Service(),
  };

  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
}; 